module.exports = __webpack_public_path__ + "img/menu-plus-off.41600398.svg";